import { Parser } from "@json2csv/plainjs"
import {
  Button,
  CircularProgress,
  IconButton,
  Tooltip,
} from "@material-ui/core"
import { Add, GetApp } from "@material-ui/icons"
import * as FileSaver from "file-saver"
import PropTypes from "prop-types"
import React, { useContext, useEffect } from "react"
import ListTitle from "~/components/Common/ListTitle"
import AdminCard from "~/components/Users/AdminCard"
import AppContext from "~/contexts/App"
import UsersContext from "~/contexts/Users"
import Page from "~/pages/Page"
import Router from "~/router"

import PermissionsWrapper from "~/components/Common/PermissionsWrapper"
import usePermissionsRedirect from "~/hooks/usePermissionsRedirect"
import Box from "../../../../components/Common/Box"
import useStyles from "./styles"

const Admin = ({ routes = [], ...rest }) => {
  const classes = useStyles()
  usePermissionsRedirect("/users/user-list", null, "super")

  const { openDialog, setPageSubTitle, setPageTitle, openSnackBar } =
    useContext(AppContext)
  const { createAdminMutation, refetchAdmins, admins, listAdminLoading } =
    useContext(UsersContext)

  const openCreateAdmin = () => {
    openDialog("createAdminDialog", {
      createAdminFunc: createAdminMutation,
      refetchAdmins: refetchAdmins,
    })
  }

  const downloadAdmins = () => {
    const fields = [
      "created",
      "email",
      "id",
      "last_online",
      "name",
      "status",
      "super",
      "updated",
      "permissions",
      "permission_group",
    ]
    const opts = { fields }

    try {
      const parser = new Parser(opts)
      const csv = parser.parse(admins)
      var file = new Blob([csv], { type: "text/csv" })
      FileSaver.saveAs(file, `admins.csv`)
    } catch (err) {
      openSnackBar({ message: "Error download admins data" })
    }
  }

  //set admin  subtitle number
  useEffect(() => {
    setPageTitle("Admins")
    setPageSubTitle(admins?.length)
  }, [])

  return (
    <Page>
      <Box className={classes.container}>
        <Box className={classes.leftContainer}>
          <Box marginLeft="16px" position="absolute" top="0" right="0">
            <PermissionsWrapper permissionGroup="admin">
              <Tooltip title="Download data" placement="top">
                <IconButton onClick={downloadAdmins}>
                  <GetApp color="secondary" />
                </IconButton>
              </Tooltip>
            </PermissionsWrapper>
          </Box>
          <ListTitle
            list={[
              { name: "", size: "2%" },
              { name: "Name", size: "40%" },
              { name: "Email", size: "27%" },
              { name: "", size: "10%" },
              { name: "Status", size: "14%" },
              { name: "Group", size: "10%" },
              { name: "", size: "25%" },
            ]}
          />
          {listAdminLoading ? (
            <Box display="flex" justifyContent="center">
              <CircularProgress size={30} />
            </Box>
          ) : (
            admins?.map((x, i) => {
              return <AdminCard admin={x} key={i} />
            })
          )}
        </Box>
        <Box className={classes.rightContainer}>
          <PermissionsWrapper permissionGroup="super">
            <Button
              onClick={openCreateAdmin}
              variant="contained"
              color="secondary"
              startIcon={<Add fontSize="small" />}
              style={{ height: "40px" }}
            >
              Invite Admin
            </Button>
          </PermissionsWrapper>
        </Box>
      </Box>

      <Router routes={routes} {...rest} />
    </Page>
  )
}
Admin.propTypes = {
  routes: PropTypes.array,
}
export default Admin
